export default __webpack_public_path__ + "static/media/money-back.b6f8c5bc.png";